import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'

import SimulationCtx from 'src/context/simulationCtx'
import useModuleValid from 'src/utils/hooks/use-module-valid'

const SimulationModeSwitcher = () => {
    const location = useLocation()

    const hasPracticeModule = useModuleValid('practice')
    const { isEnabled, setEnabled } = useContext(SimulationCtx)

    useEffect(() => {
        if (!hasPracticeModule) {
            return
        }

        const inPracticeMode =
            location.pathname.startsWith('/practice') ||
            location.pathname.startsWith('/backstage')

        if (inPracticeMode && !isEnabled) {
            setEnabled(true)
            return
        }

        if (!inPracticeMode && isEnabled) {
            setEnabled(false)
            return
        }
    }, [hasPracticeModule, isEnabled, location.pathname, setEnabled])

    return
}

export default SimulationModeSwitcher
